import { ThemeProvider, theme } from '@primer/react';

import deepmerge from 'deepmerge';
import { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import { LazyPage } from './components-ui/loadable';
import { CommonProvider } from './contexts/common';
import { useAppDispatch } from './hooks/useAppDispatch';
import { useAppSelector } from './hooks/useAppSelector';
import { rootActions } from './state/actions/rootActions';
const AuthorizedContent = LazyPage(import("./content/AuthorizedContent"))
const UnAuthorizedContent = LazyPage(import("./content/UnAuthorizedContent"))

const customTheme = deepmerge({
  ...theme,
  fontSizes: ['11px', '13px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'],
}, {

  colorSchemes: {
    light: {
      colors: {
        accent: {
          fg: "#0969da",
          emphasis: "#0969da"
        },
        btn: {
          primary: {
            bg: "#0969da",
            focusBg: "#0969da",
            hoverBg: "#0969da",
            selectedBg: "#0969da",
            disabledBg: "rgba(84, 174, 255, 0.4)"
          }
        },
        primer: {
          border: {
            active: "#0969da"
          }
        }

      }
    }
  }
})

function App() {
  const dispatch = useAppDispatch();

  const { user } = useAppSelector(x => x.auth);
  const { themeMode } = useAppSelector(x => x.common.layout);

  useEffect(() => {
    dispatch(rootActions.auth.GET_USER_INFO_START(undefined));
  }, [])
  return (
    <Router>
      <CommonProvider>
        <ThemeProvider theme={customTheme} colorMode={themeMode}>
          <BaseStyles>

            {/* <AuthorizedContent /> */}
            {user && <>
              {/* <HubProvider> */}
              <AuthorizedContent />
              {/* </HubProvider> */}
            </>}
            {!user && <UnAuthorizedContent />}

          </BaseStyles>
        </ThemeProvider>
      </CommonProvider>
    </Router>
  );
}
export default App;
